export const tagsConstants = {
  GET_REQUEST: 'TAGS_GET_REQUEST',
  GET_SUCCESS: 'TAGS_GET_SUCCESS',
  GET_FAILURE: 'TAGS_GET_FAILURE',
};